// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"368":"bad7cf57","592":"be95b7c5","628":"f313c0ef","640":"3f518311","792":"6df12e29"}[chunkId] + ".chunk.js";
};